import * as React from 'react';
import b_ from 'b_';
import { useState } from 'react';
import moment from 'moment';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { getArticles } from '../../articles';

import './index.scss';

interface Props {
  index: number;
}

type Enhanced = Props & InjectedTranslateProps;

const b = b_.with('main-page-news-article');

const Article: React.FC<Enhanced> = ({ t, index }) => {
  const article = getArticles(t)[index];
  const [isItemHovered, setIsItemHovered] = useState(false);

  return (
    <a
      href={article.link}
      className={b()}
      target="_blank"
      rel="noopener"
      onMouseEnter={() => setIsItemHovered(true)}
      onMouseLeave={() => setIsItemHovered(false)}
    >
      <img src={isItemHovered ? article.image[1] : article.image[0]} className={b('img')} />
      <div className={b('title')}>{article.title}</div>
      <div className={b('date')}>{moment(article.date).format('D MMMM YYYY')}</div>
    </a>
  );
};

export default translate(Article);
